import 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'


ReactDOM.render(
  <App/>,
  document.getElementById('root'),
)
